import { GROUP_BY_PRIORITY_QUERY } from "services/staff-tasks";

/**
 * The grouped-list projection plus the team pill (TEAMS_FEATURE): the drawer lists name it only with
 * the flag on, since an older backend 400s the RestQL key. Its own module so the pure helpers in
 * `team-task.utils.ts` stay importable under a mocked `services/staff-tasks`.
 */
export const GROUP_BY_PRIORITY_QUERY_WITH_TEAM = `${GROUP_BY_PRIORITY_QUERY.slice(0, -1)},team{id,name,color},team_claimed_at}`;
